import snakecaseKeys from 'snakecase-keys';

import { withLogs } from '@core';

import { apiClient, ApiConfig } from '../apiClient';

import { Activity } from './activity';

/**
 * @boothOnly
 * only works in booth
 */
export const createActivityV2 = withLogs(async (clubId: number) => {
    if (!ApiConfig.isBooth) {
        throw new Error('createActivityV2: request is booth only');
    }
    const { data: activity } = await apiClient.post<Activity>(ApiConfig.path('api/v2/activities'), { clubId });
    return activity;
});

export const getCurrentActivity = withLogs(async () => {
    if (!ApiConfig.isBooth) {
        throw new Error('getCurrentActivity: request is booth only');
    }

    const { data } = await apiClient.get<Activity | null>(ApiConfig.path('api/v1/activities/current'));
    return data;
}, 'getCurrentActivity');

export type UpdateActivityParams = {
    clubId?: number;
    layoutId?: number;
};

export const updateActivity = withLogs(async (activityId: number, updateParams: UpdateActivityParams) => {
    const { data } = await apiClient.patch<Activity>(ApiConfig.path(`api/v1/activities/${activityId}`), {
        ...snakecaseKeys(updateParams),
    });
    return data;
}, 'updateActivity');

export const closeActivity = withLogs(async (activityId: number) => {
    const { status } = await apiClient.post(ApiConfig.path(`api/v1/activities/${activityId}/close`));
    if (status !== 204) {
        throw Error(`Could not close activity:${activityId}`);
    }
    return activityId;
});
